<template>
  <v-container fluid class="pa-0">
    <v-row class="mt-2 mb-4">
      <v-col cols="12">
        <v-data-table
          :key="dialog"
          :loading="isLoading"
          item-key="id"
          calculate-widths
          single-expand
          show-expand
          class="elevation-1"
          :server-items-length="totalData"
          :options.sync="pagination"
          :headers="headerTableFCL"
          :items="items"
          :item-class="itemRowBackground"
          :footer-props="{
            showCurrentPage: true,
            showFirstLastPage: true,
            'items-per-page-options': $_item_per_page,
            disablePagination: isLoading,
            disableItemsPerPage: isLoading
          }"
          :expanded.sync="expanded"
        >
          <template v-slot:[`header.isAutoAssign`]="{ header }">
            <p class="text-center mb-0">
              {{header.text}}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    x-small
                    class="mb-4"
                    v-bind="attrs"
                    v-on="on"
                    color="white">
                    mdi-information
                  </v-icon>
                </template>
                <span>{{$_strings.mou.A_A}}</span>
              </v-tooltip>
            </p>
          </template>
          <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
            <v-icon
              v-if="showExpandPickDrop(item)"
              :class="['v-data-table__expand-icon', { 'v-data-table__expand-icon--active': isExpanded }]"
              @click.stop="expand(!isExpanded)"
            >
              $expand
            </v-icon>
          </template>
          <template v-slot:[`item.sequenceOrderNo`]={item}>
            <v-text-field
              dense
              outlined
              disabled
              class="body-2 pt-2"
              :value="item.sequenceOrderNo ? fclMouRouteSequence.find((seqRoute) => seqRoute[item.sequenceOrderNo])[item.sequenceOrderNo] : null"
            ></v-text-field>
          </template>
          <template v-slot:[`item.origin`]={item}>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="blue--text"
                >
                  {{item.originLocationName}}
                </span>
              </template>
              <span>{{$_strings.order.ORIGIN}}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.destination`]=items>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="blue--text"
                >
                  {{items.item.destinationLocationName}}
                </span>
              </template>
              <span>{{$_strings.order.DESTINATION}}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.price`]={item}>
            <p>{{formatAsCurrency(item.price)}}</p>
          </template>
          <template v-slot:[`item.isAutoAssign`]={item}>
            <p class="text-center">{{item.isAutoAssign ? 'Ya' : 'Tidak'}}</p>
          </template>
          <template v-slot:[`item.transporter`]={item}>
            <p
              dense
              class="body-2"
              outlined
            >
              {{item.transportTypeName}}
            </p>
          </template>
          <template v-slot:[`item.priceMultiPick`]={item}>
            <p>{{formatAsCurrency(item.priceMultiPick)}}</p>
          </template>
          <template v-slot:[`item.priceMultiDrop`]={item}>
            <p>{{formatAsCurrency(item.priceMultiDrop)}}</p>
          </template>
          <template v-slot:[`item.isBackHauling`]={item}>
            <p>{{item.isBackHauling ? 'Ya' : 'Tidak'}}</p>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td :colspan="8">
              <v-data-table
                :headers="subHeaderTableFCL"
                :items="item.mouRoutesMultiLoc"
                hide-default-footer
                :items-per-page="100"
                class="mt-2 mb-4 elevation-1 sub_header"
              >
                <template v-slot:[`item.origin`]={item}>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="blue--text"
                      >
                        {{item.locationName}}
                      </span>
                    </template>
                    <span>Lokasi {{ item.pickDrop === 'PICKUP' ? 'Multipick' : 'Multidrop' }} </span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.pickDrop`]={item}>
                  <span>
                    {{ item.pickDrop === 'PICKUP' ? 'Multipick' : 'Multidrop' }}
                  </span>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'list-fcl-table-history',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    fetchData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      headerTableFCL: [
        {
          text: this.$_strings.order.ORIGIN,
          value: 'origin',
          class: 'white--text primary text-capitalize',
          width: '200px',
          cellClass: 'clickable',
          sortable: false,
        },
        {
          text: this.$_strings.order.DESTINATION,
          value: 'destination',
          class: 'white--text primary text-capitalize',
          width: '200px',
          cellClass: 'clickable',
          sortable: false,
        },
        {
          text: this.$_strings.order.ETA,
          value: 'etaDays',
          class: 'white--text primary text-capitalize',
          width: '150px',
          cellClass: 'clickable',
          sortable: false,
        },
        {
          text: 'Harga (Rp)',
          value: 'price',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          width: '200px',
          sortable: false,
        },
        {
          text: 'A.A',
          value: 'isAutoAssign',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$_strings.mou.TRANSPORTER,
          value: 'transporter',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          width: '200px',
          sortable: false,
        },
        {
          text: 'Multipick (Rp)',
          value: 'priceMultiPick',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          width: '200px',
          sortable: false,
        },
        {
          text: 'Multidrop (Rp)',
          value: 'priceMultiDrop',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          width: '200px',
          sortable: false,
        },
        {
          text: this.$_strings.order.BACKHAULING,
          value: 'isBackHauling',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          class: 'white--text primary text-capitalize',
          cellClass: 'clickable',
          sortable: false,
        },
      ],
      subHeaderTableFCL: [
        {
          text: 'Nama Lokasi',
          value: 'origin',
          class: 'black--text amber accent-3',
          sortable: false,
        },
        {
          text: 'Multipick / Multidrop',
          value: 'pickDrop',
          class: 'black--text amber accent-3',
          sortable: false,
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      expanded: [],
      items: [],
      totalData: 0,
    };
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.pagination = {
          page: 1,
          itemsPerPage: 10,
        };
        this.totalData = 0;
        this.items = [];
      }
    },
    pagination: {
      handler() {
        if (this.dialog) this.getData();
      },
      deep: true,
    },
  },
  methods: {
    showExpandPickDrop(item) {
      const condition1 = +item.priceMultiPick !== 0 || +item.priceMultiDrop !== 0;
      const condition2 = item.mouRoutesMultiLoc && item.mouRoutesMultiLoc.length;
      return condition1 || condition2;
    },
    formatAsCurrency(value) {
      const formatNumber = Intl.NumberFormat('id-ID');
      return `Rp. ${formatNumber.format(value) || 0}`;
    },
    async getData() {
      try {
        this.isLoading = true;
        const result = await this.fetchData(this.pagination);
        this.items = result.data.contents.map((d, index) => ({
          ...d,
          index,
        }));
        this.totalData = result.data.totalData;
      } finally {
        this.isLoading = false;
      }
    },
    itemRowBackground(item) {
      if (item.index % 2 === 0 && item.status === 'DELETE') return 'red lighten-4';
      if (item.index % 2 === 1 && item.status === 'DELETE') return 'red lighten-5';
      if (item.status === 'ADD') return 'green lighten-5';
    },
  },
};
</script>
